// extracted by mini-css-extract-plugin
export default {"selfMigrateContainer":"SelfMigrate_selfMigrateContainer__+WzGC","imgContainer":"SelfMigrate_imgContainer__B2WeB"};